import { NormalIconProps } from 'assets/icons';
import React from 'react';
import { AppTheme } from 'shared/constants/common';
import useResolvedColorScheme from 'shared/hooks/useResolvedColorScheme';

export const TimePending: React.FC<NormalIconProps> = () => {
	const { resolvedColorScheme } = useResolvedColorScheme();
	const color = resolvedColorScheme === AppTheme.DARK ? '#fff' : '#000';
	return (
		<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				opacity="0.2"
				d="M58.6666 32C58.6666 46.7276 46.7275 58.6666 31.9999 58.6666C17.2723 58.6666 5.33325 46.7276 5.33325 32C5.33325 17.2724 17.2723 5.33331 31.9999 5.33331C46.7275 5.33331 58.6666 17.2724 58.6666 32Z"
				stroke={color}
				stroke-width="2"
				stroke-linecap="round"
				stroke-dasharray="0.5 3.5"
			/>
			<path d="M58.6667 32C58.6667 17.2724 46.7277 5.33331 32.0001 5.33331" stroke={color} stroke-width="2" stroke-linecap="round" />
			<path d="M32 24V34.6667H42.6667" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
	);
};
